
import api from '../api';

const addStore = async (store) => {
  const requestData = {
    code: store.Code,
    imao_store_code: store.ImaoStoreCode,
    name: store.Name,
    city: store.City,
    district: store.District,
    address: store.Address,
    phone: store.Phone,
    table_count: Number(store.Tables),
    description: store.Description,
    status: store.Status,
    hide_from_web: Boolean(store.HideFromWeb),
    tags: store.Tags,
    interval_minutes: store.IntervalMinutes,
    promotions: store.Promotions,
    latitude: Number(store.Latitude),
    longitude: Number(store.Longitude),
    invoice_enable: Boolean(store.InvoiceEnable),
    invoice_love_codes: store.InvoiceLoveCodes || [],
    invoice_love_code_names: store.InvoiceLoveCodeNames || {},
  }

  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/store/add", requestData);
    return response.data;
  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }
}

export default addStore;
